<ng-container *ngIf="currentUser?.idVerified || currentUser?.totpEnabled || this.apiTokens.length">
  <div class="api-token-header">
    <a class="float-right iana-button"
      [ngClass]="{'iana-navigation-button-disabled': apiTokens.length > 9}"
      (click)="clickAddApiToken()">
        Add API Token
    </a>
    <div class="header-helper">API Tokens</div>
  </div>
  <div *ngIf="apiTokens.length < 1" class="content content-with-elevation">
    <ng-container>
      <common-alerts [successMessage]="successMessage"></common-alerts>
      <common-alerts [errorMessage]="errorMessage"></common-alerts>
      <p>An API Token is required to use the RZMS API. Click "Add New Token" to
        get started. Once added, all active API tokens will be displayed in this section.</p>
    </ng-container>
  </div>

  <div class="content content-with-elevation" *ngIf="apiTokens.length > 0">
    <common-alerts [successMessage]="successMessage"></common-alerts>
    <common-alerts [errorMessage]="errorMessage"></common-alerts>
    <div *ngFor="let token of apiTokens">
      <div class="grid-x basic-details-section api-token">
        <div class="cell small-8">
          <h5>{{token.name}} (ending in {{token.tokenSuffix}})</h5>
          <div class="grid-x token-info-section">
            <div class="cell small-6 token-info">Created: {{token.createdTime | commonDate}}</div>
            <div class="cell small-6 token-info">Last Used: {{token.lastAccessTime | commonDate}}</div>
            <div class="cell small-6 token-info" [ngClass]="{'red': isTokenExpired(token)}">Expires: {{token.expiryTime | commonDate}}</div>
          </div>
        </div>
        <div class="cell small-4 token-action-buttons">
          <a class="iana-button" (click)="openEditApiTokenNameModal(token)">Edit Token Name</a>
          <a class="iana-button" (click)="removeAPIToken(token)">Revoke Token</a>
        </div>
      </div>
    </div>
  </div>

  <common-smart-modal [dynamicID]="confirmationRandomID"
                      [content]="'Are you sure you want to revoke this API token? It will no longer be valid for the RZMS API.'"
                      [closeButtonText]="'Cancel'"
                      [acceptButtonText]="'Continue'"
                      [contentHeader]="'Confirmation'"
                      (proceed)="revokeToken()"
                      [commentMode]="false">
  </common-smart-modal>

  <common-smart-modal [dynamicID]="require2FARandomID"
                      [content]="modalContent"
                      [closeButtonText]="'Close'"
                      [hasAcceptButton]="false"
                      [contentHeader]="'2FA Required to Add API Tokens'">
  </common-smart-modal>

  <common-smart-modal [dynamicID]="editTokenNameRandomID"
                      [content]="''"
                      [closeButtonText]="'Cancel'"
                      [acceptButtonText]="'Save'"
                      [contentHeader]="'Token Name'"
                      [textFieldMode]="true"
                      [placeholder]="selectedApiToken?.name"
                      (proceedWithComment)="editAPITokenName($event)"
                      [commentMode]="true">
  </common-smart-modal>

  <common-smart-modal [dynamicID]="apiTokenRandomID"
                      [content]="modalContent"
                      [closeButtonText]="'Close'"
                      [acceptButtonText]="'Copy'"
                      [contentHeader]="'API Token'"
                      (proceedWithComment)="copyAPIToken()"
                      [value]="newlyCreatedToken"
                      [editable]="false"
                      [placeholder]="'Token'"
                      [required]="false"
                      [commentMode]="true">
  </common-smart-modal>

</ng-container>
